import clsx from 'clsx';
import type { ComponentProps, ReactNode } from 'react';
import { Text } from '../Text';
import styles from './Button.module.scss';
type Props = {
  asDiv?: boolean;
  blue?: boolean;
  bordered?: boolean;
  disabled?: boolean;
  fullWIdth?: boolean;
  green?: boolean;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  red?: boolean;
  rounded?: boolean;
  small?: boolean;
} & ComponentProps<'button'>;
export const Button = ({
  asDiv,
  blue,
  bordered,
  children,
  className,
  disabled,
  fullWIdth,
  green,
  icon,
  iconPosition = 'left',
  red,
  rounded,
  small,
  ...buttonHTMLAttrs
}: Props) => {
  const Component = asDiv ? 'div' : 'button';
  return <Component type='button' {...buttonHTMLAttrs as Record<string, unknown>} className={clsx(styles.wrapper, fullWIdth && styles.fullWidth, green && styles.green, red && styles.red, disabled && styles.disabled, bordered && styles.bordered, rounded && styles.rounded, blue && styles.blue, small && styles.small, iconPosition && styles[`icon-${iconPosition}`], className)} data-sentry-element="Component" data-sentry-component="Button" data-sentry-source-file="Button.tsx">
      {icon && icon}
      <Text color={bordered ? 'black' : 'white'} type={small ? 'button_small' : 'button_large'} data-sentry-element="Text" data-sentry-source-file="Button.tsx">
        {children}
      </Text>
    </Component>;
};